export default "__VITE_ASSET__BFR8vdcF__"